import { IRoute } from "@src/routes";
import CreateRegistrationPolicyPage from "./pages/CreateRegistrationPolicy";
import EditRegistrationPolicyPage from "./pages/EditRegistrationPolicyPage";
import ListRegistrationPolicyPage from "./pages/ListRegistrationPolicyPage";
import ViewRegistrationPolicyPage from "./pages/ViewRegistrationPolicyPage";
import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    path: "/pbm/registration-policies/new",
    key: "PBM_PROGRAM_REGISTRATION_POLICY_CREATE",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: CreateRegistrationPolicyPage,
  },
  {
    path: "/pbm/registration-policies/:registrationPolicyId/edit",
    key: "PBM_PROGRAM_REGISTRATION_POLICY_EDIT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: EditRegistrationPolicyPage,
  },
  {
    path: "/pbm/registration-policies/:registrationPolicyId",
    key: "PBM_PROGRAM_REGISTRATION_POLICY_VIEW",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ViewRegistrationPolicyPage,
  },
  {
    path: "/pbm/registration-policies",
    key: "PBM_PROGRAM_REGISTRATION_POLICY_VIEW",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListRegistrationPolicyPage,
  },
];

export default routes;
